import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from '../shared/dto-has-api.model';

@Api('api/app/llm-configuration')
export class LLMConfigurationDto extends DtoHasApi {
  id: number;
  name: string;
  llmProviderName;
  apiKey: string;
  createdBy: string;
  lastModificationTime: Date;
  resourceName: string;
  apiVersion: string;
  deploymentName: string;
  generativeAIModel: string;
  llmProviderId: number;
}
